import { Component, inject, ViewEncapsulation } from '@angular/core';
import { DateTimePickerComponent } from '@common/controls/date-time-picker/date-time-picker';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { selectTranslatedKey } from '@common/store/i18n/selectors/i18n.selectors';
import { i18nKeys } from '@common/utils/i18n.default';
import { MtxAMPM, MtxCalendar, MtxCalendarView, MtxClockView } from '@ng-matero/extensions/datetimepicker';
import { Store } from '@ngrx/store';

@Component({
    selector: 'st-date-time-picker-custom-header',
    templateUrl: './date-time-picker-custom-header.html',
    styleUrls: ['./date-time-picker-custom-header.scss'],
    encapsulation: ViewEncapsulation.None,
    // TODO This might not work
    //changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-date-time-picker-custom-header',
    },
})
export class DateTimePickerCustomHeaderComponent<D> {
    private store = inject(Store);
    public globalTablesService = inject(GlobalTablesService);
    private _calendar = inject(MtxCalendar<D>);
    public dateTimePicker = inject(DateTimePickerComponent);

    timeZoneLabel$ = this.store.select(selectTranslatedKey(i18nKeys.PSTWebTimeZoneLabel));

    constructor() {}

    get currentView(): MtxCalendarView {
        return this._calendar.currentView;
    }

    get type(): string {
        return this._calendar.type;
    }

    get twelvehour(): boolean {
        return this._calendar.twelvehour;
    }

    get _yearButtonLabel(): string {
        return this._calendar._yearButtonLabel;
    }

    get _yearButtonText(): string {
        return this._calendar._yearButtonText;
    }

    get _dateButtonLabel(): string {
        return this._calendar._dateButtonLabel;
    }

    get _dateButtonText(): string {
        return this._calendar._dateButtonText;
    }

    get _hourButtonLabel(): string {
        return this._calendar._hourButtonLabel;
    }

    get _hoursButtonText(): string {
        return this._calendar._hoursButtonText;
    }

    get _minuteButtonLabel(): string {
        return this._calendar._minuteButtonLabel;
    }

    get _minutesButtonText(): string {
        return this._calendar._minutesButtonText;
    }

    get _clockView(): MtxClockView {
        return this._calendar._clockView;
    }

    get _AMPM(): MtxAMPM {
        return this._calendar._AMPM;
    }

    _yearClicked(): void {
        this._calendar._yearClicked();
    }

    _dateClicked(): void {
        this._calendar._dateClicked();
    }

    _hoursClicked(): void {
        this._calendar._hoursClicked();
    }

    _minutesClicked(): void {
        this._calendar._minutesClicked();
    }

    _ampmClicked(ampm: MtxAMPM): void {
        this._calendar._ampmClicked(ampm);
    }

    get multiYearSelector(): boolean {
        return this._calendar.multiYearSelector;
    }
}
